module.exports = __webpack_public_path__ + "img/organization-cloud.ffd73b9.svg";